import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const MetricsDashboardContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  width: '100%',
  gridTemplateColumns: 'repeat(4, 1fr)',
  gridTemplateRows: '1fr',
  gap: theme.spacing(1),
}));
